module.exports = __webpack_public_path__ + "img/Build.5f11061b.png";